import React from 'react';
import { QuoteIcon, StarIcon, MapPinIcon } from 'lucide-react';
interface Testimonial {
  quote: string;
  industry: string;
  location: string;
}
const testimonials: Testimonial[] = [{
  quote: 'I was drowning in debt after a disastrous Covid lockdown. Once we were able to trade again I was left with a bounce back loan and trade debts. After talking to Debt Rescue I was able to sell my company for £1 and carry on without any debt. The best thing I ever did.',
  industry: 'Fleet Tracking Company',
  location: 'Hinckley'
}, {
  quote: "After receiving a winding up petition from a trade creditor I did not know where to turn. Although I owed £21,000 I was owed £46,000. Debt Rescue were able to buy me some time with the court to bring in the £46,000. I was then able to pay off my creditor and move on. They dealt with everything including 3 court hearings and the creditor's solicitor to resolve the matter.",
  industry: 'Construction Company',
  location: 'South Wales'
}, {
  quote: 'I had the bailiffs coming to my home address which was very stressful for my family. I then received a winding up petition which I ignored until 4 days before the hearing. I was then contacted by Debt Rescue who were able to transfer the company to them within 24 hours. They dealt with the winding up petition and I never heard from a bailiff or creditor again.',
  industry: 'Building Company',
  location: 'Barnsley'
}, {
  quote: 'Once we were able to open after Covid lockdowns we were unable to reach the same business levels as before. With all the debt accrued it was impossible to carry on. Once we got threatened with legal action and bailiffs we turned to Debt Rescue who made all our financial problems go away. Thankfully I can sleep again.',
  industry: 'Beauty Company',
  location: 'London'
}];
export const Testimonials: React.FC = () => {
  return <div className="grid md:grid-cols-2 gap-8" data-id="element-189">
      {testimonials.map((testimonial, index) => <div key={index} className="bg-white p-8 rounded-xl shadow-sm border border-gray-100 relative" data-id="element-190">
          <div className="absolute top-6 right-6 text-red-600 opacity-20" data-id="element-191">
            <QuoteIcon className="h-16 w-16" data-id="element-192" />
          </div>
          <div className="flex mb-4" data-id="element-193">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className="h-5 w-5 text-yellow-400 fill-current" data-id="element-194" />)}
          </div>
          <p className="text-gray-700 mb-6 italic relative z-10 leading-relaxed" data-id="element-195">
            "{testimonial.quote}"
          </p>
          <div className="border-t border-gray-100 pt-4" data-id="element-196">
            <p className="font-bold text-gray-900" data-id="element-197">{testimonial.industry}</p>
            <p className="text-sm text-gray-500 flex items-center mt-1" data-id="element-198">
              <MapPinIcon className="h-4 w-4 mr-1" data-id="element-199" />
              {testimonial.location}
            </p>
          </div>
        </div>)}
    </div>;
};